module.exports = __webpack_public_path__ + "media/whimmIcon.da494140.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/whimmIcon.png
// module id = ./src/assets/whimmIcon.png
// module chunks = 0